import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';
import type { ResumedPortfolioType } from '@customTypes/portfolio';

const useGetTeamPortfolios = () => {
  const [portfolios, setPortfolios] = useState<ResumedPortfolioType[]>([]);
  const [loading, setLoading] = useState(true);

  const getTeamPortfolios = useCallback(async (id: string) => {
    setLoading(true);
    try {
      const response = await api.get(`/teams/${id}/portfolios`);
      setPortfolios(response.data);
    } catch (error) {
      toast.error('Erro ao carregar os portfólios da equipe. Tente novamente mais tarde.');
      datadogRum.addError(new Error('Fail to fetch team portfolios'), {
        error,
        teamId: id,
      });
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    getTeamPortfolios,
    portfolios,
    loading,
  };
};

export default useGetTeamPortfolios;
